export enum DocFlowCategory {
    Group = "GROUP",
    Holder = "HOLDER",
    Share_Holder = "SHARE_HOLDER",
    All = "ALL"
}